export const portugeseTranslation = {
  'Les lignes de commandes ont été mises à jour avec succès !':
    'As linhas de comando foram actualizadas com sucesso!',
  'Le texte a été enregistré avec succès': 'O texto foi registado com sucesso',
  'La traduction a été enregistrée avec succès':
    'A tradução foi salva com sucesso',
  'Texte + Traduction enregistré avec succès':
    'Texto + Tradução foi salva com sucesso',
  'Nombre de mots': 'Número de palavras',
  Lingala: 'Lingala',
  'Prénom/Nom du client': 'Nome próprio/último nome do cliente',
  Bashkir: 'Bashkir',
  "La date doit être ultérieure à aujourd'hui.":
    'A data deve ser posterior a hoje.',
  'Contenu rédigé': 'Conteúdo escrito',
  'Nom/prénom': 'Apelido/primeiro nome',
  'Mot de passe incorrect': 'Palavra-passe incorrecta',
  Institutions: 'Instituições',
  'Veuillez donner un descriptif au document téléchargé':
    'Por favor, dê uma descrição do documento descarregado',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi; Nuosu',
  Suivant: 'Próximo',
  Kannada: 'Kannada',
  'Séparer les mots clés par un "enter"':
    'Separar palavras-chave com um "enter".',
  Allemand: 'Alemão',
  Sango: 'Sango',
  'Min.': 'Min.',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    'um e-mail contendo uma ligação de redefinição de senha foi enviado para o seu e-mail',
  'Chef edito': 'escritores chefe',
  Croate: 'Croata',
  'Nb de textes': 'Nº de textos',
  Violet: 'Violeta',
  'Ce champs doit être sup ou égale nombre de texte':
    'Este campo deve ser maior ou igual ao número de texto',
  'a été activé avec succès': 'foi activada com sucesso',
  Népalais: 'Nepalês',
  'Nombre de FAQ': 'Número de FAQs',
  Urdu: 'Urdu',
  'Analyses restantes': 'Restantes análises',
  Indonésien: 'Indonésio',
  Breton: 'Bretão',
  Livrés: 'Entregue em',
  Associations: 'Associações',
  'Le client': 'O cliente',
  'Révision demandée': 'Revisão solicitada',
  "Une erreur s'est produite, veuillez réessayer":
    'Ocorreu um erro, por favor tente novamente',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Actualização não autorizada à medida que os textos forem sendo entregues',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'Para adicionar texto (optimização do conteúdo existente)',
  Gaélique: 'Gaélico',
  'La ligne de commande pour': 'A linha de comando para',
  'Business/Management': 'Negócios/Gestão',
  Serbe: 'Sérvio',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Indique abaixo os seus pedidos de modificações, tendo em conta as nossas condições de engomagem',
  'rédacteurs trouvés': 'escritores encontrados',
  'Kirghiz ; Kirghiz': 'Kirghiz; Kirghiz',
  Différence: 'Diferença',
  'en cours': 'em curso',
  'Sami du Nord': 'Sami do Norte',
  Comparer: 'Comparar',
  Lituanien: 'Lituano',
  'Typix - Mon tableau de bord': 'Typix - O meu tablier',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Deve ter pelo menos 8 caracteres com uma letra maiúscula, um número, um carácter especial e não idêntico ao nome',
  Webmaster: 'Webmaster',
  'Veuillez saisir des champs valides': 'Por favor introduza campos válidos',
  Basque: 'Basco',
  'Exporter .csv': 'Exportar .csv',
  'Confirmer le nouveau mot de passe': 'Confirmar nova senha',
  "Pas d'options": 'Sem opções',
  'Banque/Assurance': 'Banca/Seguros',
  'Vos demandes': 'Os seus pedidos',
  'Coût d\u2019achat': 'Custo de aquisição',
  Tamil: 'Tâmil',
  'Le texte a été supprimé avec succès': 'O texto foi eliminado com sucesso',
  'Mes Commandes': 'As minhas encomendas',
  Zoulou: 'Zulu',
  Afficher: 'Ver',
  Texte: 'Texto',
  Islandais: 'Islandês',
  Russe: 'Russo',
  'Tous les textes': 'Todos os textos',
  Czech: 'Checo',
  'Comparaison hors ligne': 'Comparação off-line',
  Téléphonie: 'Telefonia',
  'Valider le texte': 'Validar o texto',
  'Votre text ne de doit pas dépasser 500 mots':
    'O seu texto não deve exceder 500 palavras',
  'Coquilles (double espace, « s »\u2026)': 'Conchas (espaço duplo, "s"...)',
  'le consultant': 'o consultor',
  Coréen: 'Coreano',
  'Nb de Silo': 'Nº de Silos',
  Validés: 'Validado',
  'non attribuées': 'não atribuído',
  Néerlandais: 'Holandês',
  'Voulez-vous vraiment supprimer': 'Quer realmente apagar',
  Rundi: 'Rundi',
  Regional: 'Regional',
  'Compte client': 'Conta de cliente',
  Global: 'Global',
  'Tous les rôles': 'Todos os papéis',
  Musique: 'Música',
  Perso: 'Pessoal',
  Kinyarwanda: 'Kinyarwanda',
  'Il semblerait que tu n\u2019aies plus de crédit d\u2019analyse':
    'Parece que não tem mais crédito de análise',
  Bambara: 'Bambara',
  Sortir: 'Saia',
  optionel: 'opcional',
  'Temps restant': 'Tempo restante',
  Ukrainien: 'Ucraniano',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa; Chewa; Nyanja',
  'Votre demande de révision a bien été envoyée.':
    'O seu pedido de revisão foi enviado.',
  'Typix - Créer rédacteur': 'Typix - Criar um escritores',
  "n'existe pas": 'não existe',
  Hindi: 'Hindi',
  'ne peut pas être supprimé car il est lié à des sites web':
    'não pode ser apagado porque está ligado a websites',
  'Commandes en cours': 'Encomendas em curso',
  'Textes livrés': 'Textos entregues',
  Validation: 'Validação',
  'Non attribuées': 'Não atribuído',
  'Voulez-vous vraiment désactiver': 'Quer realmente desactivar',
  'Catalan ; Valencien': 'catalão; valenciano',
  'Nombre de textes restants': 'Número de textos restantes',
  'Ne doit pas contenir votre nom': 'Não deve conter o seu nome',
  Documentation: 'Documentação',
  Kazakh: 'Cazaque',
  'Numéro invalide': 'Número inválido',
  'Veuillez saisir un texte ou importer un fichier.':
    'Por favor, introduza um texto ou importe um ficheiro.',
  'Nb de FAQ': 'N.º de FAQs',
  Analyser: 'Analisar',
  Turc: 'Turco',
  'Toute demande n\u2019ayant pas été précisée lors du brief':
    'Qualquer pedido não especificado no resumo',
  Wallon: 'Valão',
  Birmane: 'Birmanês',
  Irlandais: 'Irlandês',
  Oriya: 'Oriya',
  'Réinitialiservotre mot de passe': 'Redefinir a sua palavra-passe',
  Cuisine: 'Cozinha',
  'Haïtien ; créole haïtien': 'Haitiano; crioulo haitiano',
  'Vous ne pouvez pas supprimer le rédacteur':
    'Não se pode apagar o escritores',
  Validé: 'Validado',
  "cet email n'existe pas": 'este e-mail não existe',
  Historique: 'História',
  Confirmer: 'Confirme',
  'à cocher si le nombre de mots est différent par texte':
    'a ser assinalado se o número de palavras for diferente por texto',
  'Fiche du site web ': 'Ficha do sítio Web',
  Désactiver: 'Desactivar',
  'Travaux/BTP': 'Obras/construção',
  'La fiche du website': 'A folha do sítio web',
  'Si le contenu ne respecte pas les règles du brief':
    'Se o conteúdo não respeitar as regras do brief',
  Norvégien: 'Norueguês',
  '0 rédacteurs': '0 escritores',
  indisponible: 'não disponível',
  Venda: 'Venda',
  Maori: 'Maori',
  'Textes revisés': 'Textos revistos',
  'Status texte': 'Estado do texto',
  'textes livrés en attente de validation':
    'textos entregues a aguardar validação',
  'Typix - Mon Profile': 'Typix - O meu perfil',
  'le client': 'o cliente',
  Romanche: 'Romanche',
  'URL du site': 'URL do sítio',
  'nouvelles notifications': 'novas notificações',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; Maldivian',
  'Êtes vous sur de vouloir sauvegarder le texte':
    'Tem a certeza que quer guardar o texto',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Por favor adicione um texto inicial para guardar o texto como um rascunho',
  Xhosa: 'Xhosa',
  'Le contrat pour le client': 'O contrato para o cliente',
  rédacteurs: 'escritores',
  'Ce champ est obligatoire': 'Este campo é obrigatório',
  'Tarif/Mot': 'Taxa/palavra',
  Tadjik: 'Tajik',
  'Réf devis': 'Citação de referência',
  'Rechercher un rédacteur': 'Procura de um escritor',
  Albanais: 'Albanês',
  Galicien: 'Galego',
  Disponibilité: 'Disponibilidade',
  'Les deux mots de passe ne sonts pas identiques':
    'As duas palavras-passe não são idênticas',
  Tibétain: 'Tibetano',
  'Typix - Gestion des utilisateurs': 'Typix - Gestão de utilizadores',
  'Ossétien ; Ossétique': 'Ossetista; Ossetic',
  Tswana: 'Tswana',
  'Ajouter un client': 'Adicionar um cliente',
  'Séparez les mots-clés par un " Enter ".':
    'Separar as palavras-chave com um "Enter".',
  'Zhuang ; Chuang': 'Zhuang; Chuang',
  Thématiques: 'Temas',
  'Nb mots/texte': 'Nº de palavras/texto',
  Commerce: 'Comércio',
  'Voir les commandes': 'Ver as encomendas',
  'Nombre de mots par texte': 'Número de palavras por texto',
  'Lien drive...': 'Ligação de condução...',
  'Hollandais ; Flamand': 'Holandês; Flamengo',
  'Mon profil': 'O meu perfil',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'Este campo deve ser maior que 0 porque a facturação não é real',
  'Le texte a été validé avec succès': 'O texto foi validado com sucesso',
  Jeux: 'Jogos',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    'Quer realmente remover a linha de comando para',
  'Ndebele, Nord ; Ndebele Nord': 'Ndebele, Norte; Ndebele Norte',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'Eclesiástico Eslavónico; Velho Eslavónico; Eclesiástico Eslavónico; Velho Búlgaro; Velho Eclesiástico Eslavónico',
  Swahili: 'Swahili',
  Voyage: 'Viagens',
  'Nombre de mot à ajouter': 'Número de palavras a acrescentar',
  'Liste des rédacteurs': 'Lista de escritores',
  'le rédacteur': 'o escritores',
  Kanuri: 'Kanuri',
  rédacteur: 'escritores',
  Tatar: 'Tártaro',
  'Roumain ; Moldave ; Moldovan': 'Romeno; Moldavo',
  'Le texte initial de': 'O texto original do',
  'Mail clients': 'Correio do cliente',
  'Le contrat de': 'O contrato de',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'pelo menos uma letra minúscula e uma maiúscula, um carácter especial e um número',
  Transport: 'Transportes',
  'Nombre total de mots (existants et ajoutés) :':
    'Número total de palavras (existentes e acrescentadas) :',
  'Rechercher par mail, prénom, nom, site...':
    'Pesquisa por e-mail, nome, apelido, site...',
  'Nombre de mot à ajouter (Min/Max) : ':
    'Número de palavras a acrescentar (Min/Máx) :',
  Compte: 'Conta',
  'Tourisme/Loisirs': 'Turismo/Lazer',
  'Nouveau texte': 'Novo texto',
  Max: 'Max',
  'Kalaallisut ; Groenlandais': 'Kalaallisut; Gronelândia',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Oops...! Há um ou mais erros na janela de intervalo semântico. Por favor verifique o seu conteúdo para corrigi-los/eles e voltar a submeter o seu texto.',
  'ne peut pas être supprimé pour le moment':
    'não pode ser apagado neste momento',
  'Le texte': 'O texto',
  URL: 'URL',
  "Un utilisateur existe déjà avec l'email":
    'Já existe um utilizador com o e-mail',
  Cree: 'Cree',
  Prénom: 'Primeiro nome',
  'commandes prête': 'encomendas prontas',
  Réinitialiser: 'Reinicialização',
  'Veuillez fournir une date valide': 'Por favor forneça uma data válida',
  'Kuanyama ; Kwanyama': 'Kuanyama; Kwanyama',
  'Luxembourgeois ; Letzeburgesch': 'Luxemburguês; Letzeburgesch',
  Suédois: 'Sueco',
  'Confirmer le mot de passe': 'Confirmar palavra-passe',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'Este campo é obrigatório e só pode ter números',
  Sciences: 'Ciência',
  Tchétchène: 'Checheno',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    'é o único cliente de um site, outros devem ser adicionados para o remover',
  'Le mot de passe de confirmation ne correspond pas':
    'A palavra-chave de confirmação não corresponde',
  Swati: 'Swati',
  Danois: 'Dinamarquês',
  Sauvegarder: 'Guardar',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Favor alterar a seguinte informação: título e/ou palavra-chave',
  'importer un document': 'importar um documento',
  Maltais: 'Maltês',
  'Nb de mots': 'Nº de palavras',
  'Les données fournies sont invalides': 'Os dados fornecidos são inválidos',
  'Livraison estimée': 'Entrega estimada',
  'Grec moderne (1453-)': 'Grego moderno (1453-)',
  Avestan: 'Avestan',
  Inuktitut: 'Inuktitut',
  'Nombre total de mots ajoutés': 'Número total de palavras adicionadas',
  'le contenu présente des inexactitudes': 'o conteúdo contém imprecisões',
  Finnois: 'Finlandês',
  'Ajouter un admin': 'Adicionar um administrador',
  'Min/Max': 'Min/Máx',
  'Modifier le consultant': 'Modificar o consultor',
  'Liste des clients': 'Lista de clientes',
  'Nom client': 'Nome do cliente',
  Vert: 'Verde',
  'Mots clés manquants': 'Palavras-chave em falta',
  Lao: 'Lao',
  Somali: 'Somali',
  'Nb de silo par texte': 'Nº de silos por texto',
  Italien: 'Italiano',
  'La commande a été mis à jour avec succès !':
    'A encomenda foi actualizada com sucesso!',
  Bosniaque: 'Bósnio',
  'Thématiques d\u2019expertise': 'Temas de especialização',
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'Esta é a palavra-chave que se esqueceu',
  'a été désactivé avec succès': 'foi desactivado com sucesso',
  Kongo: 'Kongo',
  'Postuler à la commande': 'Pedir a encomenda',
  'mot-clé': 'palavra-chave',
  Abkhazien: 'Abkhazian',
  Mongolien: 'Mongol',
  'Typix - Fiche site web': 'Typix - Website',
  'Mail envoyé': 'Correio enviado',
  Géorgien: 'Georgiano',
  'Si des phrases ne sont pas dans un français correct':
    'Se as frases não estiverem em francês correcto',
  'En cours': 'Em curso',
  voir: 'ver',
  "Date d'ajout": 'Data adicionada',
  'Tarif au mot': 'Taxa por palavra',
  Thai: 'Thai',
  'Détails du texte': 'Detalhes do texto',
  'Commandes en retard': 'Encomendas tardias',
  disponible: 'disponível',
  Droit: 'Certo',
  Azerbaïdjanais: 'Azerbaijano',
  'Ajouter un consultant': 'Adicionar um consultor',
  'Dans le cadre d\u2019une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'Ao reproduzir o conteúdo, apenas serão suportados os seguintes itens',
  'doit comprendre au moins 8 charactères':
    'deve conter pelo menos 8 caracteres',
  'Titre de la commande': 'Título do pedido',
  'Langues bihari': 'Línguas Bihari',
  'Livraison estimé au': 'Entrega estimada por',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    'O número de textos na ordem não pode ser inferior ao número de textos atribuídos ao(s) escritor(es). Por favor, altere primeiro as informações na linha de comando',
  'Date de livraison': 'Data de entrega',
  'Voulez-vous vraiment supprimer le contrat de': 'Quer realmente abolir a',
  'Facturation au réel': 'Facturação efectiva',
  'Gap sémantique': 'Abertura semântica',
  Estonien: 'Estónio',
  Wolof: 'Wolof',
  'Coût d\u2019achat max/mot': 'Custo máximo de compra/palavra-palavra',
  'Détail de la commande': 'Detalhes da encomenda',
  'Export en cours de téléchargement\u2026': 'Exportação a ser carregada...',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textesde la commande':
    'Este campo é obrigatório e deve ser inferior ou igual ao número total de textos na ordem',
  Arabe: 'árabe',
  Bislama: 'Bislama',
  'Mail client': 'Correio do cliente',
  '(Titre, mot clé, url, balise, méta-description)':
    '(Título, palavras-chave, url, tag, meta-descrição)',
  'Typix - Nouvelle commande': 'Typix - Nova encomenda',
  'Révision en attente': 'Revisão pendente',
  'Le consultant': 'O consultor',
  Entreprise: 'Empresa',
  Aragonais: 'Aragonês',
  Kashmiri: 'Kashmiri',
  'a été activé': 'foi activado',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (Associação Internacional de Línguas Auxiliares)',
  Actualités: 'Notícias',
  'Votre décision a été prise en compte avec succès':
    'A sua decisão foi tida em conta com sucesso',
  Afrikaans: 'Afrikaans',
  'contenu en attente de vérification client':
    'conteúdo a aguardar verificação do cliente',
  'Fiche du rédacteur': 'Ficheiro do escritores',
  Outillage: 'Ferramentas',
  'Typix - Détails de la commande': 'Typix - Detalhes da encomenda',
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Adicione ou complete o seu conteúdo abaixo:',
  Ewe: 'Ewe',
  'contenu en attente de repasse rédacteur':
    'conteúdo pendente de replay escritores',
  'La commande a été supprimé avec succès':
    'A encomenda foi eliminada com sucesso',
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'Expressões ou frases francesas que não lhe convêm',
  Corse: 'Córsega',
  Modifier: 'Editar',
  'Nb de GMB': 'Nº de GMBs',
  Oromo: 'Oromo',
  Polish: 'Polaco',
  'Insérez votre gap sémantique avec l’occurrence':
    'Insira a sua lacuna semântica com a ocorrência',
  'Nb de textes à optimiser': 'Número de textos a serem optimizados',
  Mode: 'Modo',
  Akan: 'Akan',
  'Révisions effectués': 'Revisões efectuadas',
  'Modifier l\u2019admin': 'Editar o administrador',
  'Télécharger le document': 'Descarregar o documento',
  Hausa: 'Hausa',
  'Notes rédacteurs': 'Notas dos escritores',
  Quechua: 'Quechua',
  Féroïen: 'Faroês',
  'Modifier le rédacteur': 'Mudar o escritores',
  Mail: 'Correio',
  Rédacteurs: 'Escritores',
  'Typix - Détails du texte': 'Typix - Detalhes do texto',
  Hongrois: 'Húngaro',
  'Bon pour livraison': 'Bom para entrega',
  'Au réel': 'No mundo real',
  'Hiri Motu': 'Hiri Motu',
  Hébreu: 'Hebraico',
  'Nombre total de mots ajoutés :': 'Número total de palavras acrescentadas :',
  Komi: 'Komi',
  'Doit être inférieur au nombre maximum':
    'Deve ser menor do que o número máximo',
  'Nom du texte': 'Nome do texto',
  'Ajouter un rédacteur': 'Adicionar um escritores',
  Ou: 'Ou',
  Utilisateurs: 'Utilizadores',
  Heures: 'Horas',
  'Santé/Bien-être': 'Saúde/bem-estar',
  'Interlingue ; Occidental': 'Interlinguística; Ocidental',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Letão',
  Anglais: 'Inglês',
  Envoyer: 'Enviar',
  'Tableau de bord': 'Painel de instrumentos',
  'Demande de révision': 'Pedido de revisão',
  'Résultat sémantique': 'Resultado semântico',
  'Chercher un rédacteur': 'Procura de um escritores',
  'Ce champs est obligatoire': 'Este campo é obrigatório',
  Rédaction: 'escritoresial',
  'Modifier le client': 'Modificar o cliente',
  'Voulez-vous vraiment supprimer le rédacteur':
    'Quer realmente apagar o escritores',
  Titre: 'Título',
  Langue: 'Idioma',
  'Mot clé': 'Palavras-chave',
  'Les demandes suivantes ne seront pas prises en compte':
    'Não serão consideradas as seguintes candidaturas',
  'délai dépassé': 'prazo não cumprido',
  Tchouvache: 'Tchouvache',
  Ganda: 'Ganda',
  Twi: 'Twi',
  'Contrat déjà existant, veuillez modifier les informations':
    'Contrato existente, por favor modifique a informação',
  Igbo: 'Igbo',
  Yiddish: 'Yiddish',
  'Limburgan ; Limburger ; Limburgish': 'Limburgan; Limburger; Limburgish',
  'Commandes validées': 'Ordens validadas',
  'listeRedacteur-': 'listRedactor-',
  Étape: 'Etapa',
  'Energie/Environnement': 'Energia/Ambiente',
  Min: 'Min',
  Gujarati: 'Gujarati',
  'ne doit pas inclure votre nom/prénom':
    'não deve incluir o seu nome/primeiro nome',
  'Typix - Fiche rédacteur': 'Typix - Ficheiro do escritor',
  'révisions effectuées en attentes de validation':
    'revisões efectuadas até à validação',
  'Textes validés': 'Textos validados',
  Art: 'Arte',
  Dzongkha: 'Dzongkha',
  Polyvalent: 'Versátil',
  Sundanese: 'Sundanese',
  'Nb total de textes': 'Número total de textos',
  'Nombre de mots gérés': 'Número de palavras geridas',
  "L'émail": 'Esmalte',
  'Afficher les résultats': 'Mostrar resultados',
  'Frison occidental': 'Frisiano Ocidental',
  'Modification effectuée avec succès': 'Modificação concluída com sucesso',
  'Balise titre': 'Etiqueta de título',
  'Typix - Mon profil': 'Typix - O meu perfil',
  'email invalide': 'e-mail inválido',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Por favor adicione uma url para que possa guardar o texto como um rascunho',
  Macédonien: 'Macedónio',
  'Votre candidature a bien été envoyée': 'A sua candidatura foi enviada',
  'E-mail': 'Correio electrónico',
  Fulah: 'Fulah',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Adicione ou complete o seu conteúdo abaixo',
  Manx: 'Manx',
  'Ajout de mots-clés avec la fréquence restante':
    'Acrescentar palavras-chave com a frequência restante',
  'Fiche du site web': 'Ficha do sítio Web',
  Contacter: 'Contacto',
  Fidjien: 'Fijianas',
  Déconnexion: 'Desconexão',
  email: 'e-mail',
  'Nombre de textes': 'Número de textos',
  'Enregistrer et informer client': 'Registo e informação dos clientes',
  'Date de validation': 'Data de validação',
  'Tonga (Îles Tonga)': 'Tonga (Ilhas Tonga)',
  Javanais: 'Javanês',
  Portugais: 'Português',
  Biélorusse: 'Bielorrusso',
  'Pour ajouter un nouveau texte': 'Para adicionar um novo texto',
  'Enfant/Puéri': 'Criança/Puperium',
  'Mots clés': 'Palavras-chave',
  Emploi: 'Emprego',
  'Voulez-vous vraiment supprimer la commande de': 'Quer realmente remover o',
  'Mot clé': 'Palavra-chave',
  Consultants: 'Consultores',
  Volapük: 'Volapük',
  Services: 'Serviços',
  'mot-clé (fréquence)': 'palavra-chave (frequência)',
  'Ne plus afficher ce message': 'Não voltar a mostrar esta mensagem',
  Consultant: 'Consultor',
  "Une erreur s'est produite": 'Ocorreu um erro',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Pelo menos 8 caracteres com uma letra maiúscula, um número, um carácter especial',
  'Pushto ; Pashto': 'Pushto; Pashto',
  Français: 'Francês',
  validées: 'validado',
  'Url du site': 'Url do site',
  Précédent: 'Anterior',
  'car celui-ci a déjà rédigé des textes':
    'porque este último já redigiu textos',
  'Kikuyu ; Gikuyu': 'Kikuyu; Gikuyu',
  Brouillons: 'Esboços',
  Ido: 'Ido',
  'Contenu disponible': 'Conteúdo disponível',
  Enseignement: 'Ensinar',
  'a été livré avec succès': 'foi entregue com sucesso',
  Chinois: 'Chinês',
  Vietnamien: 'Vietnamita',
  'Nouveau client': 'Novo cliente',
  'Votre profil a été mis à jour avec succès.':
    'O seu perfil foi actualizado com sucesso.',
  Consignes: 'Instruções',
  'Mot de passe': 'Senha',
  Annuler: 'Cancelar',
  Non: 'Não',
  Nom: 'Nome',
  Guarani: 'Guarani',
  "il y'a des commandes liés à au site web":
    'há encomendas relacionadas com o sítio web',
  Score: 'Pontuação',
  'Mot de passe mis à jour avec succès': 'Senha actualizada com sucesso',
  Latin: 'Latim',
  Technologie: 'Tecnologia',
  Internet: 'Internet',
  Nauru: 'Nauru',
  'a été créé avec succès': 'foi criada com sucesso',
  Roumain: 'Romeno',
  Assamais: 'Assamês',
  'Khmer central': 'Khmer Central',
  'Navajo ; Navaho': 'Navajo; Navaho',
  'Panjabi ; Punjabi': 'Punjabi; Punjabi',
  'Analyse/Limite': 'Análise/Limite',
  Grec: 'Grego',
  Ojibwa: 'Ojibwa',
  'Mes Projets': 'Os meus projectos',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n\u2026':
    'palavra-chave1 (2)\npalavra-chave2 (1)\npalavra-chave3 (1)\npalavra-chave4 (2)\n...',
  'ajouter un texte': 'adicionar um texto',
  'Détail de la prestation': 'Detalhes do serviço',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    'Tem a possibilidade de exportar o relatório de uma ou mais encomendas. Para exportar todas as encomendas de um cliente, basta clicar no ícone amarelo de download',
  'Gestion des utilisateurs': 'Gestão de utilizadores',
  'livré et inférieur au nombre de texte non affecté':
    'entregue e menos do que o número de textos não atribuídos',
  'Date deadline validation client': 'Prazo de validação do cliente',
  Aymara: 'Aymara',
  Validées: 'Validado',
  Notes: 'Notas',
  'Nombre de GMB': 'Número de GMBs',
  'résultats sur': 'resultados sobre',
  'Prénom / Nom du client': 'Nome / Nome do cliente',
  'Tout télécharger': 'Descarregar tudo',
  'Champs obligatoires': 'Campos obrigatórios',
  Éditer: 'Editar',
  'Coller le texte initial dans le champs ci-dessous':
    'Colar o texto original no campo abaixo',
  'ID rédacteur': 'ID do escritores',
  Arménien: 'Arménio',
  'Grande distribution': 'Distribuição em grande escala',
  Welsh: 'Galês',
  Herero: 'Herero',
  'Enrichissement sémantique': 'Enriquecimento semântico',
  'Détail de la prestation du contenu': 'Detalhes da entrega do conteúdo',
  Noir: 'Preto',
  'Ajouter un texte': 'Acrescentar um texto',
  Traduction: 'Tradução',
  'Immo/Defisc': 'Propriedade/Taxa',
  'Brief détaillé': 'Resumo detalhado',
  'Séparez les mots-clés par un Enter .':
    'Separe as palavras-chave com um Enter .',
  Prix: 'Prémios',
  'mot de passe oublié': 'Palavra-passe esquecida',
  'Ndebele, South ; South Ndebele': 'Ndebele, Sul; Ndebele do Sul',
  'Demander une révision': 'Pedir uma revisão',
  'Demander une repasse globale': 'Solicitar uma revisão abrangente',
  'Sotho, Southern': 'Sotho, Sul',
  'Le titre de la commande existe déjà': 'O título da encomenda já existe',
  'Félicitations !': 'Parabéns!',
  Kurde: 'Curdo',
  Adresse: 'Endereço',
  Espagnol: 'Espanhol',
  Ndonga: 'Ndonga',
  'En retard': 'Tarde',
  'a été ajouté avec succès': 'foi adicionado com sucesso',
  Commandes: 'Encomendas',
  'a été mis en brouillon': 'foi redigido',
  'Rédacteur attribué': 'escritores designado',
  Rechercher: 'Pesquisa',
  'Nouvelle commande': 'Nova encomenda',
  'Commandes non attribuées': 'Encomendas não atribuídas',
  'Le texte a été mis en brouillon': 'O texto foi redigido',
  'Contact edito': 'Contacto edito',
  Langues: 'Línguas',
  Orange: 'Laranja',
  'Nynorsk norvégien': 'Norueguês Nynorsk',
  Shona: 'Shona',
  Turkmène: 'Turcomenos',
  'contenu repassé, en attente validation client':
    'conteúdo engomado, à espera de validação pelo cliente',
  'Nombre de mots rédigés': 'Número de palavras escritas',
  Malay: 'Malaio',
  'Nombre de Silo': 'Número de Silo',
  Oui: 'Sim',
  Automobile: 'Automotivo',
  Résultats: 'Resultados',
  Afar: 'Afar',
  'Tâche - id tâche': 'Tarefa - id tarefa',
  'Ce champ est obligatoire doit être supérieur à 0':
    'Este campo é obrigatório e deve ser superior a 0',
  'Vous êtes sûr': 'Tem a certeza',
  'Réinitialiser votre mot de passe': 'Redefinir a sua palavra-passe',
  Sindhi: 'Sindhi',
  Bengali: 'Bengali',
  'Bokmål, norvégien ; Bokmål norvégien': 'Bokmål, norueguês; Bokmål norueguês',
  'Nombre de Jours': 'Número de dias',
  'Min/Max mots': 'Palavras Min/Max',
  Slovène: 'Esloveno',
  Site: 'Sítio Web',
  'Sinhala ; Cingalais': 'Sinhala; Sinhalês',
  Bulgare: 'Búlgaro',
  'Liste des commandes': 'Lista de encomendas',
  "L'utilisateur": 'O utilizador',
  Uzbek: 'Uzbeque',
  'Titre du texte': 'Título do texto',
  Postuler: 'Aplicar em',
  'Nb de textes par Silo': 'Nº de textos por Silo',
  'Nombre total de mots (existants et ajoutés)':
    'Número total de palavras (existentes e acrescentadas)',
  'Max.': 'Máx.',
  Beauté: 'Beleza',
  Humanitaire: 'Humanitário',
  Telugu: 'Telugu',
  'Recherche par rédacteur ou texte': 'Pesquisar por autor ou texto',
  'Balise meta-description': 'Meta etiqueta de descrição',
  Malgache: 'Malgaxe',
  Tagalog: 'Tagalog',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'Este campo deve ser superior a 0 e inferior a 1',
  'Le rédacteur': 'O escritores',
  'a été mis à jour avec succès': 'foi actualizado com sucesso',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'Deve ter pelo menos 8 caracteres com uma letra maiúscula, um número, um símbolo e não deve ser idêntico ao nome.',
  'textes en plus': 'mais textos',
  'Format souhaité': 'Formato desejado',
  Chamorro: 'Chamorro',
  Malayalam: 'Malayalam',
  'Détail ligne de commande': 'Detalhe da linha de encomenda',
  'Veuillez préciser la date': 'Por favor especifique a data',
  Pali: 'Pali',
  Clients: 'Clientes',
  'Total facturé': 'Total facturado',
  'contenu validé par le client': 'conteúdo validado pelo cliente',
  'Occitan (post 1500)': 'Occitano (pos 1500)',
  Japonais: 'Japonês',
  Avaric: 'Avaric',
  'Voulez-vous vraiment activer': 'Quer realmente activar',
  Sanskrit: 'Sânscrito',
  'Toutes les notifications': 'Todas as notificações',
  Marathi: 'Marathi',
  Persan: 'Persa',
  'La commande pour le client': 'A encomenda para o cliente',
  'Intitulé de la commande': 'Título do pedido',
  Samoan: 'Samoan',
  Autres: 'Outros',
  Sport: 'Desporto',
  "il y'a des commandes liés au site web ":
    'há encomendas relacionadas com o sítio web',
  'Ajout de mots-clé avec la fréquence restante':
    'Acrescentar palavras-chave com a frequência restante',
  'a été supprimé avec succès': 'foi removido com sucesso',
  Postulé: 'Publicado em',
  Literie: 'Roupa de cama',
  'Édité par le client': 'Editado pelo cliente',
  Cornouailles: 'Cornualha',
  Tigrinya: 'Tigrinya',
  Textes: 'Textos',
  'Soumettre un nouveau texte': 'Submeter um novo texto',
  Téléphone: 'Telefone',
  Deadline: 'Data limite',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    'Ocorreu um erro. Por favor, verifique a sua entrada ou tente novamente mais tarde.',
  Marshallais: 'Marshall',
  "La demande d'ajout de crédit est envoyée":
    'O pedido para adicionar crédito é enviado',
  'Le rédacteur ': 'O escritores',
  'Demander des crédits': 'Pedido de crédito',
  "Cette commande n'existe pas": 'Este comando não existe',
  Inupiaq: 'Inupiaq',
  Tahitien: 'Tahitiano',
  Admins: 'Admins',
  'Mettez des mots-clés avec fréquence':
    'Definir palavras-chave com frequência',
  Notifications: 'Notificações',
  'en retard': 'final',
  "l'admin": 'a administração',
  'Mail rédacteurs': 'escritores de correio',
  Amharique: 'Amárico',
  Societe: 'Empresa',
  Tsonga: 'Tsonga',
  'Nombre de textes ajoutés': 'Número de textos adicionados',
  Société: 'Empresa',
  Yoruba: 'Iorubá',
  'Le texte a été livré avec succès': 'O texto foi entregue com sucesso',
  'Mettez votre texte': 'Ponha o seu texto',
  "Oups....! Une erreur s'est produite": 'Oops....! Ocorreu um erro',
  'Prénom/Nom': 'Primeiro nome/último nome',
  'Max doit être sup à Min': 'O máximo deve ser maior que o mínimo',
  'Importer un autre document': 'Importar outro documento',
  'Votre demande a expirée .. veuillez refaire une autre':
    'O seu pedido expirou ... por favor faça outro',
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Por favor, corrija o formato da sua lacuna semântica a fim de salvar o texto como um rascunho',
  Exemple: 'Exemplo',
  Slovaque: 'Eslovaco',
  Finance: 'Finanças',
  Réactiver: 'Reativar',
  'Nb textes': 'Nº de textos',
  'Intitulé commande': 'Título da encomenda',
  Supprimer: 'Eliminar',
  Brouillon: 'Projecto',
  'Mots clés restants': 'Restantes palavras-chave',
  Date: 'Data',
  Rôle: 'Papel',
  'Ce champs doit être sup à 0': 'Este campo deve ser superior a 0',
  'Maison/Déco': 'Início/Decoração',
  'Vous avez': 'Tem',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'Esta linha de comando não pode ser apagada porque parte do seu texto foi entregue',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'verifique o seu e-mail e clique no link para continuar!',
  Sarde: 'Sardenha',
  'Note rédacteur': 'Nota do escritores',
  'Uighur ; Uyghur': 'Uighur; Uyghur',
  Name: 'Nome',
  'Commandes intelligentes': 'Comandos smart',
  'Commandes avec révision': 'Comandos smart + review',
  'Type de contenu': 'Tipo de conteúdo',
  'Fiche produit': 'Ficha de produto',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Redação premium',
  'Rédaction avec révision': 'Redação smart + review',
  'Rédaction intelligente': 'Redação smart',
  PREMIUM: 'PREMIUM',
  Type: 'Tipo',
  Editer: 'Editar',
  'Tous les types': 'Todos os tipos',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',
  'Factures traitées': 'Facturas processadas',
  'Factures à valider': 'Faturas a validar',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Não é possível gerar a fatura! Por favor, tente novamente',
  'Récapitulatif de facturation': 'Resumo da faturação',
  'Demander une modification': 'Solicitar uma modificação',
  'Valider et envoyer la facture': 'Validar e enviar a fatura',
  'Demande de modification': 'Pedido de modificação',
  'La facture a été validé avec succès!': 'A fatura foi validada com sucesso!',
  "Oups un erreur c'est produit!": 'Ops, ocorreu um erro!',
  'Nombre de texte': 'Número de textos',
  'Nombre de mot par texte :': 'Número de palavras por texto:',
  Paiement: 'Pagamento',
  Virement: 'Transferência bancária',
  Délai: 'Prazo',
  'Référence de votre facture': 'Referência da sua fatura',
  'Coût au mot': 'Custo por palavra',
  'Montant global de la commande': 'Valor total do pedido',
  'Votre facture': 'Sua fatura',
  'Importer votre facture': 'Importar sua fatura',
  'Pas de fichier disponible': 'Nenhum arquivo disponível',
  Télécharger: 'Baixar',
  Relancer: 'Reenviar',
  'Générer la facture': 'Gerar a fatura',
  Payée: 'Pago',
  'En cours de paiement': 'Em processo de pagamento',
  'En cours de validation': 'Em processo de validação',
  'A envoyer': 'A ser enviado',
  'Modification demandée': 'Modificação solicitada',
  'Référence de facture est obligatoire':
    'A referência da fatura é obrigatória',
  'Le coût au mot doit être un nombre':
    'O custo por palavra deve ser um número',
  'Le coût au mot doit être un nombre positif':
    'O custo por palavra deve ser um número positivo',
  'Le coût au mot est obligatoire': 'O custo por palavra é obrigatório',
  'Le montant global de la commande doit être un nombre':
    'O valor total do pedido deve ser um número',
  'Le montant global de la commande doit être un nombre positif':
    'O valor total do pedido deve ser um número positivo',
  'Le montant global de la commande est obligatoire':
    'O valor total do pedido é obrigatório',
  'Bill reference existe déja , veuillez réessayer':
    'A referência da fatura já existe, por favor, tente novamente',
  'La facture a été envoyée avec succès!': 'A fatura foi enviada com sucesso!',

  'Montant estimé': 'Valor estimado',
  Action: 'Ação',
  Facture: 'Fatura',
  Statut: 'Status',
  Factures: 'Faturas',
  'Valider la facture': 'Validar a fatura',
  'La relance a été envoyée avec succès !':
    'O lembrete foi enviado com sucesso!',
  'La demande de modification a été envoyée avec succès !':
    'O pedido de modificação foi enviado com sucesso!',
  'Le cout est trop élevé': 'O custo está muito alto',
  'Le montant global de la commande est trop élevé ':
    'O valor total do pedido está muito alto',
  jours: 'dias',
  'Factures à envoyer': 'Faturas a enviar',
  'Valider le paiement': 'Validar pagamento',
  'Générer une facture': 'Gerar uma fatura',
  'Montant rédacteur': 'Valor do redator',
  'Montant estimé par Typix': 'Valor estimado pelo Typix',
  'Voir la modification': 'Ver modificação',

  'Tag de Titre': 'Tag do título',
  'Meta description': 'Meta descrição',
  'Nom du produit': 'Nome do produto',
  Avantages: 'Vantagens',
  'Description détaillée': 'Descrição detalhada',
  'En cours de modification': 'Em modificação',
  'Mes Factures': 'Minhas faturas',
  'En attente de validation': 'Aguardando validação',
  'les valeurs négatives ne sont pas autorisées':
    'Valores negativos não são permitidos.',
  'Texte Seulement': 'Apenas texto',
  'Traduction Seulement': 'Apenas tradução',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    'O lembrete pode ser enviado 20 dias após o envio da fatura',
  Instructions: 'Instruções',
  'Votre avis pour la commande': 'Seu feedback para o pedido',
  'Votre évaluation est précieuse pour nous ! Merci !':
    'Sua avaliação é valiosa para nós! Obrigado!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    'Ocorreu um erro ao enviar sua avaliação. Por favor, tente novamente mais tarde!',
  Evaluer: 'Avaliar',
  Commentaire: 'Comentário',
  'Votre commantaire': 'Seu comentário',
  Note: 'Nota',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Seu feedback é valioso para nós e nos ajuda a melhorar nossos serviços.',
  'Verifier la facture': 'Verifique a fatura',

  ' Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Seu feedback é valioso para nós e nos ajuda a melhorar nossos serviços. Obrigado por compartilhar sua avaliação conosco!',
  'Notes rédacteur': 'Notas do redator',
  'Avis client': 'Opiniões de clientes',
  'Pas de commantaire': 'Sem comentário',
  "Qu'avez vous pensé de votre commande?": 'O que você achou do seu pedido?',
  'Evaluation de la commande': 'Avaliação do pedido',
  'Rédiger un commentaire': 'Escrever um comentário',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Contribua para nos permitir oferecer serviços de redação da mais alta qualidade compartilhando seus comentários.',
  'Que pouvons-nous améliorer?': 'O que podemos melhorar?',
  Continuer: 'Continuar',
  'Le dernier texte a été validé avec succès':
    'O último texto foi validado com sucesso',
  'Rechercher par rédacteur, commandes, et montant':
    'Pesquisar por redator, pedidos e valor',
  obligatoire: 'obrigatório',
  'Note admin': 'Nota do administrador',
  'Note client': 'Nota do cliente',
  Partie: 'Parte',
  'Vous venez de valider tous les contenus rédigés par ':
    'Você acabou de validar todo o conteúdo escrito por ',
  "Qu'en avez vous pensé": 'O que você achou',
  'La facture a été générée avec succès !': 'A fatura foi gerada com sucesso!',
  'La taille du titre et/ou la méta-description est trop courte':
    'O comprimento do título e/ou da meta descrição está muito curto',

  'Demande de révision globale': 'Requerer uma revisão global',
  Valider: 'Validar',
  'Obligatoire en cas d’optimisation ou traduction':
    'Obrigatório em caso de otimização ou tradução',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Seu comentário...',
  'Ex : "Contenus de très bonne qualité':
    'Ex: "Conteúdo de muito boa qualidade"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    'Você poderia, por favor, atribuir este/a escritor/a para futuras encomendas?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'Este botão serve para informar o cliente de que o texto original já continha enchimento de palavras-chave',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Editar o texto',
  Ajouter: 'Adicionar',
  'Demande examen': 'Pedido de exame',
  'Recherche de mots clés à haute densité': 'Pesquisa de keyword stuffing',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    'Ops, parece que há keyword stuffing no seu texto: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    'Ops, parece que há keyword stuffing (muitas ocorrências de uma ou mais palavras-chave) no texto original.',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    'Por favor, certifique-se de que a densidade de palavras-chave esteja otimizada para SEO (um máximo de uma ocorrência a cada 50 palavras).',
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'Para isso, por favor, não edite o texto existente e envie gentilmente um pedido de exame ao suporte.',
  'Votre demande a été bien envoyée !': 'O seu pedido foi enviado com sucesso!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    'Houve um problema ao enviar o seu pedido.',
  'Veuillez attendez pour le  keyword Stuffing analyse':
    'Por favor, aguarde a análise de keyword stuffing.',
  'Inserez le maillage interne': 'Inserir a malha interna',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    'Certifique-se de que a densidade das palavras-chave está otimizada para SEO (máximo de uma ocorrência a cada 50 palavras).\nSe encontrar um termo que possa ter várias significados (Exemplo: Former / Formation / Form ou Matelas / Matelassé), você pode solicitar uma revisão ao suporte.',
  'Mots clés à haute densité dans le texte actuel':
    'Palavras-chave de alta densidade no texto atual',
  'Mots clés à haute densité dans le texte initial':
    'Palavras-chave de alta densidade no texto inicial',
  'Texte en cours de rédaction !': 'Texto em processo de redação !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    'Tem certeza de que deseja confirmar o texto? Certifique-se primeiro de ter salvo as alterações.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    'Informação de última hora! Seu saldo de créditos logo estará esgotado :( Para antecipar, não hesite em solicitar mais créditos agora para concluir seu pedido.',
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    'Deseja confirmar o URL atual ou modificá-lo?',
  'Veuillez fournir une URL valide': 'Por favor, forneça um URL válido.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    'Por favor, indique abaixo a URL da página onde o conteúdo foi integrado:',
  'Contenu en ligne': 'Conteúdo online',
  'Télécharger le document de révision': 'Baixar o documento de revisão',
  'Date d’envoi': 'Data de envio',
  Information: 'Informação',
  Enregistrer: 'Salvar',
  'Textes en ligne': 'Textos online',
  'Livrer les textes': 'Entregar os textos',
  Indisponible: 'Indisponível',
  Disponible: 'Disponível',
  'Les textes ont été livrés avec succès.':
    'Os textos foram entregues com sucesso.',
  'Le texte a été livré avec succès.': 'O texto foi entregue com sucesso.',
  'Les textes ont été validés avec succès.':
    'Os textos foram validados com sucesso.',
  'Le texte a été validé avec succès.': 'O texto foi validado com sucesso.',
  'Voulez-vous vraiment valider les Textes de la commande':
    'Você realmente quer validar os textos do pedido?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Você realmente quer entregar os textos do pedido?',
  'Fiche produit longue': 'Ficha de produto longa',
  'Fiche produit courte': 'Ficha de produto curta',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'Um texto é muito longo e não pode ser exportado para o Excel.',
  'Mettre un texte en brouillon en livré':
    'Mudar um texto de rascunho para entregue',
  'Remettre un texte validé à livré': 'Mudar um texto validado para entregue',
  'Invalider le texte': 'Invalidar o texto',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'Gostaria de mudar minha senha: como faço isso?',
  'Comment mettre un contenu en bon pour livraison ?':
    'Como definir o conteúdo pronto para entrega?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    'Não consigo salvar meu conteúdo como "rascunho"',
  'Typix n’a pas enregistré mes dernières modifications':
    'O Typix não salvou minhas últimas alterações?',
  'Comment rédiger une création de contenu ?':
    'Como escrever criação de conteúdo?',
  'Comment rédiger une optimisation de contenu ?':
    'Como escrever otimização de conteúdo?',
  'Je ne vois plus ma commande – que faire ?':
    'Não vejo mais meu pedido – o que fazer?',
  'Comment générer une facture ?': 'Como gerar uma fatura?',
  'Je ne peux pas generer ma facture : que faire ?':
    'Não consigo gerar minha fatura: o que fazer?',
  'Tuto process Typix global': 'Processo global Typix - tutorial',
  'Tuto mise en ligne des contenus': 'Como carregar conteúdo - tutorial',
  'Modification mot de passe': 'Alteração de senha',
  'Le test ne me convient pas': 'O teste não me convém',
  'Comment valider un contenu dans Typix ?': 'Como validar conteúdo no Typix?',
  'Tuto Facturation': 'Tutorial de facturare',
  'Le statut du contenu a bien été modifié':
    'O status do conteúdo foi modificado com sucesso',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'A lacuna semântica desta palavra-chave ainda não foi validada, por favor contacte o suporte Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Esta palavra-chave não existe no MONETORING, por favor verifique com o suporte Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Recuperar a lacuna',
  'Le statut du contenu a bien été modifié':
    'O status do conteúdo foi modificado com sucesso',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'A lacuna semântica desta palavra-chave ainda não foi validada, por favor contacte o suporte Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Esta palavra-chave não existe no MONETORING, por favor verifique com o suporte Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Recuperar a lacuna',
  'Traduction premium': 'Tradução premium',
  'Rédaction et/ou Traduction intelligente':
    'Redação e/ou Tradução inteligente',
  'Rédaction et/ou Traduction premium': 'Redação e/ou Tradução premium',
  'Rédaction et/ou Traduction avec révision':
    'Redação e/ou Tradução com revisão',
  'Rédaction et/ou Traduction intelligente':
    'Redação e/ou Tradução inteligente',
  'Traduction avec révision': 'Tradução com revisão',
  'Traduction intelligente': 'Tradução inteligente',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'O número de palavras encomendadas é superior ao vendido',
  'Rédaction et/ou Traduction premium': 'Redação e/ou tradução premium',
  'Rédaction et/ou Traduction smart + review':
    'Redação e/ou tradução inteligente + revisão',
  'Rédaction et/ou Traduction smart': 'Redação e/ou tradução inteligente',
  'Nom Silo': 'Nome Silo',
  'Remettre en brouillon': 'Reverter para rascunho',
  'Bon pour Livraison Vérifié': 'Verificado para entrega',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    'Tem certeza de que deseja reverter os textos do pedido para rascunho',
  'La vérification du texte a été annulée':
    'A verificação do texto foi cancelada',
  'Voulez-vous vraiment annuler la vérification du texte?':
    'Tem certeza de que deseja cancelar a verificação do texto?',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    'Tem certeza de que deseja regenerar todo o conteúdo?',
  'Je suis sûr(e)': 'Estou certo/a',
  'Non, revenir en arrière': 'Não, voltar atrás',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'marque se o pedido pretende ter um redator exclusivo para o cliente',
  Gouvernance: 'Governança',
  'Modification à valider': 'Modificação a ser validada',
  Rédacteur: 'Editor',
  'Nouveau site web': 'Novo site',
  'Mail Chef Project': 'E-mail do gerente de projeto',
  'Site web': 'Site',
  'Liste des siteweb': 'Lista de sites',
  'Projets non attribuées': 'Projetos não atribuídos',
  'Projets en cours': 'Projetos em andamento',
  'Projets en retard': 'Projetos atrasados',
  'Projets validées': 'Projetos validados',
  'Projets smart + reviews': 'Projetos smart + reviews',
  'Projets smart': 'Projetos smart',
  'Ajouter un siteweb': 'Adicionar um site',
  'Nouveau projet': 'Novo projeto',
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  ////
  Balises: 'Etiquetas',
  Lisibilité: 'Legibilidade',
  'Longueur des paragraphes': 'Comprimento dos parágrafos',
  Phrases: 'Frases',
  'de +100 mots sur': 'com mais de +100 palavras sobre',
  Phrase: 'Frase',
  'de +20 mots sur': 'com mais de +20 palavras sobre',
  'Notre recommandation': 'Nossa recomendação',
  'Longueur du texte': 'Comprimento do texto',
  'Formats de contenus variés': 'Formatos de conteúdo variados',
  'par rapport au top 3 de vos concurrents':
    'em comparação com o top 3 dos seus concorrentes',
  'Vous êtes': 'Você é',
  'Vous avez un score global de': 'Você tem uma pontuação global de',
  'pour une moyenne du secteur à': 'para uma média do setor de',
  'GAP comblé - Mission accomplie': 'Lacuna preenchida – Missão cumprida',
  'Mots clé restants': 'Palavras-chave restantes',
  'Phrases de +20 mots': 'Frases com mais de 20 palavras',
  'Titre H1': 'Título H1',
  'Titres H2': 'Títulos H2',
  'Dans le texte actuel': 'No texto atual',
  'Dans le texte initial': 'No texto inicial',
  mots: 'palavras',
  objectif: 'objetivo',
  phrase: 'frase',
  paragraphe: 'parágrafo',
  'Temps de lecture': 'Tempo de leitura',
  'requis ( Bullet point, Bon à savoir,Sommaire)':
    'necessário (bullet points, bom saber, resumo)',
  'de contenu sur': 'quantidade de conteúdo sobre',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet':
    'Parabéns! O número de palavras corresponde à quantidade de informações necessárias para o tema.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !':
    'Parabéns! Seu conteúdo não contém nenhuma frase com mais de 20 palavras!',
  'Félicitations ! Votre contenu est aéré et facilite la lecture':
    'Parabéns! Seu conteúdo está bem espaçado e facilita a leitura.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.':
    'Parabéns! Seu conteúdo usa formatos variados que dinamizam a leitura e destacam informações importantes.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte':
    'Parabéns! O conteúdo possui uma única etiqueta H1 e inclui a palavra-chave principal.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>':
    'Parabéns! O conteúdo é estruturado de forma coerente e contém pelo menos duas etiquetas <h2>.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.':
    'Parabéns! Seu conteúdo contém links internos equilibrados que não atrapalham a leitura.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!':
    'Parabéns! A pontuação de enriquecimento é superior a 85%!',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.':
    'Parabéns! Seu texto não está super-otimizado para a palavra-chave alvo.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet':
    'O número de palavras deve corresponder à quantidade de informações importantes para o tema.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.':
    'É importante adaptar o nível de vocabulário ao seu público. Vocabulário muito simples infantiliza, muito complexo torna o conteúdo inacessível.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page':
    'Mais de 70% dos usuários não leem frases com mais de 20 palavras → use frases concisas para aumentar o tempo na página.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.":
    'Conteúdo com blocos de parágrafos muito compactos prejudica a experiência do usuário e aumenta a taxa de rejeição.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.":
    'Use diferentes formatos de exibição para uma leitura mais clara e confortável.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ':
    'Conteúdo otimizado deve conter uma única etiqueta H1 e mencionar a palavra-chave.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.':
    'Para uma estrutura de conteúdo ótima, são necessárias pelo menos 2 etiquetas H2.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.':
    'Links internos são uma ótima maneira de conectar uma página com outras páginas relacionadas ou complementares.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation':
    'Conteúdo otimizado deve obter pontuação de enriquecimento mínima de 85%. Remover conteúdo semântico reduzirá a pontuação de otimização.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ':
    'Repetir a palavra-chave muitas vezes penaliza o SEO. Idealmente, não ultrapassar 2,35% (aprox. 2 repetições a cada 100 palavras).',
  'Aucune balise H1 trouvée.': 'Nenhuma etiqueta H1 encontrada.',
  'Balise H1 contient le mot-clé.': 'A etiqueta H1 contém a palavra-chave.',
  'Balise H1 présente mais sans le mot-clé.':
    'A etiqueta H1 está presente, mas não contém a palavra-chave.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} etiquetas H2 encontradas, {{count_with_kw}} com palavra-chave.',
  ' balises H2 trouvées,': ' etiquetas H2 encontradas,',
  ' avec mot-clé.': ' com palavra-chave.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.':
    'Muito fácil de ler: acessível para crianças ou pessoas com nível básico de leitura.',
  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.':
    'Fácil de ler: compreensível para a maioria dos adultos e adolescentes.',
  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique':
    'Difícil de ler: requer bom nível de leitura, às vezes formação acadêmica.',
  'Très difficile à lire : Réservé à un public expert ou très averti':
    'Muito difícil de ler: destinado a leitores especialistas ou avançados.',
  'Wording adapté': 'Redação adequada',
  "La balise H1 est essentielle pour l'optimisation SEO.":
    'A etiqueta H1 é essencial para otimização SEO.',
  'Une seule balise H1 avec le mot-clé est recommandée.':
    'Recomenda-se apenas uma etiqueta H1 com a palavra-chave.',
  'Ajoutez le mot-clé dans la balise H1.':
    'Adicione a palavra-chave na etiqueta H1.',
  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.':
    'Adapte seu vocabulário ao público. Muito simples infantiliza, muito complexo exclui.',
  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.':
    'Conteúdos web são lidos rapidamente. Tempo muito longo pode desanimar.',
  'Information sur la structure': 'Informações sobre a estrutura',
  'Information sur le résultat sémantique': 'Informações sobre o resultado semântico',
  'Information sur les balises HTML': 'Informações sobre as etiquetas HTML',
  'Information sur le keyword stuffing': 'Informações sobre keyword stuffing',
  ////////////////////////////////

  'Derniers contenus rédigés': 'Últimos conteúdos redigidos',
  'voir plus': 'Ver mais',
  'texte': 'Texto',
  'date d\'ajout': 'Data de adição',
  'titre du projet': 'Título do projeto',
  'Date de création': 'Data de criação',
  'dernières projets créés': 'Últimos projetos criados',
  '% projets par statut de validation :': '% de projetos por estado de validação:',
  'non attribués': 'Não atribuídos',
  'en cours': 'Em curso',
  'en retard': 'Atrasados',
  'validées': 'Validados',
  'smart + reviews': 'Smart + Avaliações',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + Revisão',
  'Statut d\'avancement des contenus:': 'Estado de progresso dos conteúdos:',
  'Nombre de textes publiés :': 'Número de textos publicados:',
  'Nb de textes publiés': 'N.º de textos publicados',
  'Top ranked': 'Melhor classificados',
  'Mot clé': 'Palavra-chave',
  'Clicks': 'Cliques',
  'Clicks (Y-1)': 'Cliques (Y-1)',
  'Position': 'Posição',
  'Sessions': 'Sessões',
  'Sessions (Y-1)': 'Sessões (Y-1)',
  'Evolution performance': 'Evolução do desempenho',
  'Pourcentage': 'Percentagem',
  'Livré': 'Entregue',
  'Publié': 'Publicado',
  'Suivez vos contenus et projets en temps réel': 'Acompanhe os seus conteúdos e projetos em tempo real',
  'Tableau de bord': 'Painel de controlo',
  'Titre du projet': 'Título do projeto',
  'Conversions': 'Conversões',
  'Impressions': 'Impressões',
  'Jan': 'Jan',
  'Fév': 'Fev',
  'Mars': 'Mar',
  'Avr': 'Abr',
  'Mai': 'Mai',
  'Juin': 'Jun',
  'Juil.': 'Jul',
  'Août': 'Ago',
  'Sept': 'Set',
  'Oct': 'Out',
  'Nov': 'Nov',
  'Déc': 'Dez',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'Para ativar esta funcionalidade, adicione o nosso endereço ',
  'à votre ': 'à sua ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'depois clique aqui para iniciar a análise.',
  'all devices': 'todos os dispositivos',
  'Desktop': 'Computador',
  'Mobile': 'Telemóvel',
  '30 days': '30 dias',
  '7 days': '7 dias',
  '90 days': '90 dias',
  'Aucun projet créé pour le moment.': 'Nenhum projeto criado de momento.',
  'Lancer votre premier projet': 'Inicie o seu primeiro projeto',
  'Aucun contenu disponible pour ce site web.': 'Nenhum conteúdo disponível para este site web.',
  'Mes contenus': 'Os meus conteúdos',
  'Type de contenu': 'Tipo de conteúdo',
  'Date d\'ajout': 'Data de adição',
  'URL': 'URL',
  'Status': 'Estado',
  'Date de livraison': 'Data de entrega',
  'Date de validation': 'Data de validação',
  'Date de déploiement': 'Data de implementação',
  'Action': 'Ação',
  'Aucun contenu pour ce filtre.': 'Nenhum conteúdo para este filtro.',
  'Chargement...': 'A carregar...',
  'Aucun contenu.': 'Nenhum conteúdo.',
  'Précédent': 'Anterior',
  'Suivant': 'Seguinte',
  'fiche produit': 'Ficha de produto',
  'Page catégorie': 'Página de categoria',
  'Fiche GMB': 'Ficha GMB',
  'store locator': 'Localizador de lojas',
  'redaction': 'Redação',
  'traduction': 'Tradução',
  'Fiches produit SEO': 'Fichas de produto SEO',
  'Derniers projets crées': 'Últimos projetos criados',
  'Agent IA': 'Agente IA',
  'Dérniére mise à jour': 'Última atualização',
  'Créer un nouveau contenu': 'Criar novo conteúdo',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Redija um texto otimizado com IA — rápido, relevante e eficaz.',
  'Validé': 'Validado',
  'En ligne': 'Online',
  'Fiches GMB': 'Fichas GMB',
  'Fiches store locator': 'Fichas de localizador de lojas',
  'Pages catégories': 'Páginas de categoria',
  'Traduction IA': 'Tradução IA',
  'Actions': 'Ações',
  'Traduire un nouveau contenu': 'Traduzir novo conteúdo',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Traduza automaticamente os seus conteúdos com precisão multilingue.',
  'Nom du projet': 'Nome do projeto',
  'Chef de projet': 'Gestor de projeto',
  'Deadline du projet': 'Prazo do projeto',
  'Informations globales': 'Informações gerais',
  'Contenu du projet': 'Conteúdo do projeto',
  'Séléctionner le type de contenu': 'Selecionar o tipo de conteúdo',
  'Sélectionner un agent IA personnalisé': 'Selecionar um agente IA personalizado',
  'Créer un agent IA personnalisé': 'Criar um agente IA personalizado',
  'Liens utiles': 'Ligações úteis',
  'Rédacteur(s)': 'Redator(es)',
  'Deadline': 'Prazo',
  'Nb textes': 'N.º de textos',
  'IA + Revue par rédacteur': 'IA + Revisão por redator',
  'Ajouter un projet': 'Adicionar um projeto',
  'Projets': 'Projetos',
  'Non attribués': 'Não atribuídos',
  'Rédaction IA': 'Redação IA',
  'Résultats sur': 'Resultados em',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': 'Tem a certeza de que quer eliminar este agente IA?',
  'Mes agents IA': 'Os meus agentes IA',
  'Tous': 'Todos',
  'Rédaction': 'Redação',
  'Traduction': 'Tradução',
  'Rechercher': 'Pesquisar',
  'Sélectionner un site': 'Selecionar um site',
  'Créer un agent IA personnalisé': 'Criar um agente IA personalizado',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Defina a missão, o papel, o idioma, o tipo de conteúdo e muito mais.',
  'Nouvel agent': 'Novo agente',
  'Rôle :': 'Função:',
  'Type de contenu :': 'Tipo de conteúdo:',
  'Langue :': 'Idioma:',
  'Siteweb :': 'Website:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Selecionar um LLM',
  'Fiche produit smart': 'Ficha de produto inteligente',
  'Détails du texte': 'Detalhes do texto',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Palavra-chave*, URL, Título, Meta-descrição)',
  'URL siteweb*': 'URL do website*',
  'Balise titre': 'Título',
  'Balise méta-description': 'Meta-descrição',
  'Sélectionner un site web': 'Selecionar um website',
  'Sélectionner un agent IA': 'Selecionar um agente IA',
  'Lancer': 'Iniciar',
  'Relancer': 'Relançar',
  'Génération en cours...': 'Geração em curso...',
  'Générer': 'Gerar',
  'Enregistrement...': 'A gravar...',
  'Enregistrer ': 'Guardar',
  'Livrer': 'Entregar',
  'Livraison...': 'A entregar...',
  'En ligne...': 'Online...',
  "Derniers contenus ajoutés": "Conteúdos mais recentes",
  ////

  'Nom de l\'agent': 'Nome do agente',
  'Site web': 'Site',
  'Mission': 'Missão',
  'Langue de traduction': 'Idioma de tradução',
  'Langue': 'Idioma',
  'Tonalité': 'Tom',
  'Cible / Audience': 'Público-alvo',
  'Base de connaissance locale': 'Base de conhecimento local',
  'Base de connaissance en ligne': 'Base de conhecimento online',
  'Sélect. fichiers': 'Selecionar arquivos',
  'Ex: URL1, URL2': 'Ex.: URL1, URL2',
  'Annuler': 'Cancelar',
  'Mettre à jour': 'Atualizar',
  'Valider': 'Validar',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages':
    'Ex.: um parágrafo sobre os tipos de intervenção, um parágrafo sobre as vantagens',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels':
    'Ex.: os guarda-chuvas dobráveis abrem automaticamente, os outros são manuais',
  '📚 Base de connaissances': '📚 Base de conhecimento',

  'Type de produits / services proposés par le site*': 'Tipo de produtos/serviços oferecidos pelo site*',
  'Règles rédactionnelles': 'Regras de redação',
  'Lexique recommandé': 'Léxico recomendado',
  'Expressions interdites': 'Expressões proibidas',
  'Instructions de personnalisation': 'Instruções de personalização',

  "🧩 Informations générales": "🧩 Informações gerais",
  "🗣️ Ton & Audience": "🗣️ Tom e público",
  "📝 Structure & Rédaction": "📝 Estrutura e redação",
  "📚 Base de connaissances": "📚 Base de conhecimento",
  "Structure de texte attendu": "Estrutura de texto esperada",
  "Enrichissement SEO": "Otimização SEO",
  "traduction IA": "Tradução IA",
  "Traduction en cours...": "Tradução em andamento...",
  "Traduire": "Traduzir",
  "Créer votre assistant éditorial sur mesure": "Crie seu assistente editorial personalizado",
  "Votre texte traduit": "Seu texto traduzido",
  "Détail du projet": "Detalhes do projeto",
  "Détail d'attribution": "Detalhes de atribuição",
  "Détail des contenus": "Detalhes dos conteúdos",

  "Nom agent": "Nome do agente",
  "Rédaction": "Redação",
  "Traduction": "Tradução",
  "Mots clé": "Palavras-chave",
  "Url de la page": "URL da página",
  "Entrez le mot clé principal": "Digite a palavra-chave principal",
  "Entrez l url": "Digite a URL",
  "Date d'ajout": "Data de adição",
  "Dernière mise à jour": "Última atualização",
  "URL": "URL",
  "Status": "Status",
  "Actions": "Ações",
  "Détails du texte": "Detalhes do texto",
  "Contenus disponibles": "Conteúdos disponíveis",
  "Textes générés": "Textos gerados",

  "Veuillez d'abord sélectionner un site web": "Por favor, selecione primeiro um site",
  "Chargement des agents...": "Carregando agentes...",
  "Aucun agent disponible pour ce site": "Nenhum agente disponível para este site",
  "Sélectionner...": "Selecionar...",
  "Modifier cet agent": "Editar este agente",
  "Créer un agent IA personnalisé": "Criar um agente IA personalizado",
  "Rédaction en cours...": "Redação em andamento...",
  "Génération en cours": "Geração em andamento",
  "Rédiger un contenu": "Redigir um conteúdo",
  "Rédiger un lot de contenus": "Redigir um lote de conteúdos",
  "Url page": "URL da página",
  "Entrez l'URL cible de votre contenu (facultatif).": "Digite a URL de destino do seu conteúdo (opcional).",
  "GAP sémantique": "GAP semântico",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....":
    "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....",
  "Maillage interne": "Ligação interna",
  "Introduisez le maillage": "Introduza a ligação",
  "Introduisez le maillage interne": "Introduza a ligação interna",
  "Importer un fichier contenant la liste des thématiques à rédiger et l'IA fera le reste 😊":
    "Importe um arquivo contendo a lista de temas a redigir e a IA fará o resto 😊",
  "Importer": "Importar",
  "Saisissez le mot-clé principal de votre contenu.": "Digite a palavra-chave principal do seu conteúdo.",
  "Texte à traduire": "Texto a traduzir",
  "Saisissez le texte à traduire": "Digite o texto a traduzir",
  "Traduire un contenu": "Traduzir um conteúdo",
  "Traduire un lot de contenus": "Traduzir um lote de conteúdos",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊":
    "Importe um arquivo contendo a lista de textos a traduzir e a IA fará o resto 😊",
  "Commencer la traduction": "Começar a tradução",
  "Lancer la traduction": "Iniciar a tradução",
  "Commencer la rédaction": "Começar a redação",
  "Lancer la rédaction": "Iniciar a redação",

  'En ligne...': 'Online...',
  'Ajouter un nouveau site web': 'Adicionar um novo site',
  'Créer': 'Criar',
  'Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.': 'Selecione ou adicione os temas que refletem a sua expertise.',
  'Ajoutez ou sélectionnez une thématique': 'Adicione ou selecione um tema.',
  'Le site web a été créé avec succès': 'O site foi criado com sucesso',
  'Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.': 'Estamos a configurar os seus agentes de IA. Eles estarão prontos em breve para ajudar na geração dos seus conteúdos.',
  'Derniers contenus ajoutés': 'Últimos conteúdos adicionados',
  'Tous les sites': 'Todos os sites',
  'Sélectionner le site web': 'Selecionar o site',
  'Aucun fichier sélectionné': 'Nenhum ficheiro selecionado',
  'ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible': 'ex.: use a forma formal, utilize vocabulário compreensível para o público-alvo.',
  '🧠 Créer un agent IA': '🧠 Criar um agente IA',
  '🧠 Modifier un agent IA': '🧠 Editar um agente IA',
  'Ex : AMF (Autorité des Marchés Financiers).': 'Ex.: AMF (Autoridade dos Mercados Financeiros).',
  'Ex: bio, écologique, nom des concurrents': 'Ex.: biológico, ecológico, nomes dos concorrentes.',
  'Détailler le plus possible la structure attendue à l\'aide d\'axes de rédaction pour guider l\'IA sur les sujets à traiter et dans quel ordre': 'Detalhe ao máximo a estrutura esperada para guiar a IA sobre os temas a abordar e a ordem correta.',
  'Ajouter des éléments que l\'IA doit ou ne pas faire ou mentionner': 'Adicionar elementos que a IA deve ou não deve fazer ou mencionar.',
  'Ex: prêt-à-porter féminin': 'Ex.: pronto-a-vestir feminino',
  'Ex: Rédacteur SEO': 'Ex.: Redator SEO',
  'Indiquer la liste des urls sur lesquels l\'IA peut s\'appuyer': 'Indique a lista de URLs nos quais a IA pode apoiar-se.',
  'Créez, optimisez, performez : votre contenu prend une nouvelle dimension.': 'Crie, otimize, alcance resultados: o seu conteúdo sobe de nível.',
  'La création de contenu n\'a jamais été aussi smart.': 'A criação de conteúdo nunca foi tão inteligente.',
  'Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)': 'Aumente a sua produtividade com o poder da multi-IA. Compare e combine as melhores propostas de vários LLM, e otimize tudo com uma pontuação de conteúdo em tempo real (SEO, legibilidade, relevância).',
  'Je crée mon premier contenu SEO friendly': 'Crio o meu primeiro conteúdo otimizado para SEO.',
  'Veuillez coller le texte source....': 'Cole aqui o texto original...',
  'Enrichir': 'Enriquecer',
  'Veuillez d\'abord sélectionner un site web': 'Por favor, selecione primeiro um site.',

  "🎯 Commencez ici": "🎯 Comece aqui",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Adicione ou selecione o site que deseja acompanhar.",
  "📝 Derniers contenus créés": "📝 Últimos conteúdos criados",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Veja aqui os conteúdos mais recentes criados para o site selecionado.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Clique num texto para ver a ficha detalhada.",
  "📁 Derniers projets créés": "📁 Últimos projetos criados",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Aceda rapidamente aos últimos projetos iniciados para este site.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Clique num projeto para ver o progresso e os conteúdos associados.",
  "📊 Suivi de vos projets": "📊 Acompanhamento dos seus projetos",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "Veja o estado dos seus projetos: em curso, atrasados ou validados.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "Uma visão geral clara para acompanhar o estado global da sua produção.",
  "📑 Statut d’avancement des contenus": "📑 Estado de avanço dos conteúdos",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Acompanhe aqui o estado dos seus conteúdos: rascunhos, entregues e publicados.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ideal para identificar rapidamente onde concentrar os seus esforços.",
  "📅 Textes publiés par mois": "📅 Textos publicados por mês",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "Veja o número de textos publicados mensalmente para o site selecionado.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "Acompanhe o seu ritmo de publicação ao longo do tempo.",
  "⭐ Top mots-clés": "⭐ Palavras-chave principais",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Descubra as suas 5 palavras-chave mais eficazes segundo a Search Console.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Compare a posição, os cliques atuais e os cliques do ano anterior.",
  "📈 Activer le suivi du trafic": "📈 Ativar o acompanhamento do tráfego",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Adicione o nosso e-mail à sua Search Console para ativar esta análise.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "Depois poderá acompanhar a evolução do seu tráfego diretamente no Typix.",
  "🏠 Tableau de bord": "🏠 Painel de controlo",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Volte à vista geral: indicadores-chave, conteúdos recentes, projetos e desempenho do seu site.",
  "🤖 Agents IA": "🤖 Agentes IA",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Configure e controle os seus agentes de IA para automatizar redação e tradução, ganhando tempo nos seus conteúdos.",
  "✍️ Rédaction IA": "✍️ Redação IA",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Aceda aos geradores de IA: fichas de produto, GMB, páginas de categoria e outros conteúdos otimizados.",
  "🌍 Traduction IA": "🌍 Tradução IA",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Traduza os seus conteúdos para várias línguas em poucos cliques mantendo a coerência SEO.",
  "➕ Créer un projet": "➕ Criar um projeto",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Inicie um novo projeto de conteúdos em poucos segundos e acompanhe o progresso.",
  "📂 Gestion des projets": "📂 Gestão de projetos",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Aceda aos seus projetos não atribuídos, em curso, atrasados ou validados para acompanhar o progresso.",
  "👤 Mon profil": "👤 Meu perfil",
  "Modifiez vos informations personnelles.": "Altere as suas informações pessoais.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 Gestão de utilizadores",
  "Invitez de nouveaux membres, gérez leurs droits et organisez les équipes.": "Convide novos membros, gere direitos e organize as equipas.",
  "❓ Mon guide": "❓ Meu guia",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Reabra este guia interativo a qualquer momento para rever as principais funcionalidades do Typix.",
  'Mon guide': 'Meu guia',
  'Se déconnecter': 'Terminar sessão',
  "L'adresse email est obligatoire.": "O endereço de email é obrigatório.",
  "Le nom est obligatoire.": "O apelido é obrigatório.",
  "Le prénom est obligatoire.": "O nome próprio é obrigatório.",
  "Le mot de passe est obligatoire.": "A palavra-passe é obrigatória.",
  "La confirmation est obligatoire.": "A confirmação é obrigatória.",
  "Les mots de passe ne correspondent pas.": "As palavras-passe não coincidem.",
  "Récapitulatif": "Resumo",
  "Quitter la création": "Sair da criação",
  "Objectif du projet": "Objetivo do projeto",
  "Mode de production": "Modo de produção",
  "Répartition du travail": "Distribuição do trabalho",
  "Contexte éditorial": "Contexto editorial",
  "Rédaction": "Redação",
  "Traduction": "Tradução",
  "Créer du contenu original": "Criar conteúdo original",
  "Traduire un contenu existant": "Traduzir conteúdo existente",
  "Identification du projet": "Identificação do projeto",
  "Nom du projet": "Nome do projeto",
  "Vous pourrez modifier le nom plus tard": "Poderá alterar o nome mais tarde",
  "URL du site": "URL do site",
  "Langue": "Idioma",
  "Sélectionner une langue": "Selecionar um idioma",
  "Nombre de textes": "Número de textos",
  "12 textes disponibles": "12 textos disponíveis",
  "Chef de projet": "Gerente de projeto",
  "Aucun chef de projet assigné au siteweb": "Nenhum gerente de projeto atribuído ao site",
  "Sélectionner un chef de projet": "Selecionar um gerente de projeto",
  "Date limite du projet": "Prazo do projeto",
  "Sélectionner une date limite": "Selecionar um prazo",
  "Suivant": "Próximo",
  "Retour": "Voltar",
  "Définissez l'objectif et le cadre général de votre projet.": "Defina o objetivo e o quadro geral do seu projeto.",
  "IA": "IA",
  "Production généré par IA": "Produção gerada por IA",
  "Rédacteur": "Redator",
  "Production Rédacteur par IA": "Produção de redator por IA",
  "IA + revue humaine": "IA + revisão humana",
  "IA avec validation humaine.": "IA com validação humana.",
  "Répartissez les textes de votre projet entre vous et d'éventuels rédacteurs.": "Distribua os textos do seu projeto entre si e possíveis redatores.",
  "L'attribution à un rédacteur est optionnelle.": "A atribuição a um redator é opcional.",
  "Agent IA": "Agente IA",
  "Vous pourrez changer d'agent plus tard": "Poderá alterar o agente mais tarde",
  "Veuillez d'abord sélectionner un site web": "Por favor, selecione primeiro um site",
  "Sélectionnez le mode IA": "Selecione o modo IA",
  "Aucun agent disponible": "Nenhum agente disponível",
  "Sélectionner un agent IA": "Selecionar um agente IA",
  "Format du contenu": "Formato do conteúdo",
  "Sélectionner un format": "Selecionar um formato",
  "Nombre de mots par texte": "Número de palavras por texto",
  "Format personnalisé": "Formato personalizado",
  "définir le nombre de mots": "definir o número de palavras",
  "mots": "palavras",
  "Options avancées": "Opções avançadas",
  "Enrichissement du contenu": "Enriquecimento do conteúdo",
  "Génération Image": "Geração de Imagens",
  "Nombre d’images": "Número de Imagens",
  "Définir le nombre d’images": "Definir o número de imagens",
  "Consomment des crédits supplémentaires": "Consomem créditos adicionais",
  "IA augmentée par vos données": "IA aumentada com os seus dados",
  "Sélectionnez les personnes en charge de la relecture des contenus générés par l'IA et répartissez": "Selecione as pessoas responsáveis pela revisão dos conteúdos gerados pela IA e distribua",
  "les textes à valider.": "os textos a validar.",
  "Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,": "O revisor pode fazer correções e ajustes direcionados dentro do limite de palavras definido,",
  "sans réécrire entièrement le contenu.": "sem reescrever completamente o conteúdo.",
  "Contexte éditorial & brief détaillé du projet": "Contexto editorial e brief detalhado do projeto",
  "Ajouter des informations contextuelles pour guider et enrichir la production des contenus.": "Adicione informações contextuais para orientar e enriquecer a produção de conteúdos.",
  "Gap sémantique": "Lacuna semântica",
  "optionnel": "opcional",
  "Brief détaillé": "Brief detalhado",
  "Lien drive...": "Link drive...",
  "Lancer le projet": "Iniciar o projeto",
  "Nom du projet existant": "Nome do projeto já existe",
  "Un projet avec ce nom existe déjà dans votre espace.": "Um projeto com este nome já existe no seu espaço.",
  "Merci de choisir un nom différent pour continuer.": "Por favor, escolha um nome diferente para continuar.",
  "Erreur lors de la création du projet. Veuillez réessayer.": "Erro ao criar o projeto. Por favor, tente novamente.",
  "Félicitations !": "Parabéns!",
  "Votre projet a été créé avec succès !": "O seu projeto foi criado com sucesso!",
  "Voir le projet": "Ver o projeto",
  "Fermer": "Fechar",
  "Paramètres du compte": "Configurações da conta",
  "Site web": "Site",
  "Langue du site": "Idioma do site",
  "textes": "textos",
  "Deadline": "Prazo",
  "Type": "Tipo",
  "Rédacteur": "Redator",
  "Moi (par défaut)": "Eu (padrão)",
  "Livraison le": "Entrega em",
  "À venir": "A chegar",
  "Production généré par IA": "Produção gerada por IA",
  "Agent": "Agente",
  "Format": "Formato",
  "Enrichissement du contenu activé": "Enriquecimento do conteúdo ativado",
  "Relecteur": "Revisor",
  "texte": "texto",
  "Limite de modification": "Limite de modificação",
  "Aucune attribution": "Sem atribuição",
  "Aucun élément ajouté": "Nenhum elemento adicionado",
  "janvier": "janeiro",
  "février": "fevereiro",
  "mars": "março",
  "avril": "abril",
  "mai": "maio",
  "juin": "junho",
  "juillet": "julho",
  "août": "agosto",
  "septembre": "setembro",
  "octobre": "outubro",
  "novembre": "novembro",
  "décembre": "dezembro",
  "à": "até",
  "mots minimum": "mínimo de palavras",
  "mots maximum": "máximo de palavras",
  "Status de validation des projets": "Status de validação dos projetos",
  "Statut d'avancement des contenus": "Status de progresso do conteúdo:",
  "Total des contenus": "Total de conteúdo:",
  "Non attribué": "Não atribuído",
  "Évolution des performances": "Evolução do desempenho",
  "Position": "Posição",
  "Nombre de textes publiés": "Número de textos publicados",
  "Espace de travail AI": "Espaço de trabalho de IA",
  "Mise à jour 1.2": "Atualização 1.2",
  "Découvrez les dernières fonctionnalités, optimisations et correctifs.": "Descubra os recursos, otimizações e correções mais recentes.",
  "Projet créé": "Projeto criado",
  "Votre projet a bien été créé.": "Seu projeto foi criado com sucesso.",
  "Vous pouvez commencer à travailler dessus dès maintenant.": "Você pode começar a trabalhar nele agora mesmo.",
  "Sélectionnez le mode IA": "Selecione o modo IA",
  "Aucun agent disponible": "Nenhum agente disponível",
  "Sélectionner un agent IA": "Selecionar um agente IA",
  "Sélectionner un format": "Selecionar um formato",
  "Veuillez d'abord sélectionner un site web": "Por favor, selecione primeiro um site",
  //
  'Nouveau contenu': 'Novo conteúdo',
  'Génération en cours...': 'Geração em curso...',
  'Optimisation en cours...': 'Otimização em curso...',
  'Traduction en cours...': 'Tradução em curso...',
  'En lignes': 'Online',
  'filtres': 'Filtros',
  'trier par': 'Ordenar por',
  'Score décroissant': 'Pontuação decrescente',
  'Score croissant': 'Pontuação crescente',
  'Date de création': 'Data de criação',
  'Date de mise à jour': 'Data de atualização',
  'Date récente': 'Data mais recente',
  'Date ancienne': 'Data mais antiga',
  'Mots clés': 'Palavras-chave',
  'Éditeur': 'Editor',
  'Créateur': 'Criador',
  'Rédacteurs': 'Redatores',
  'Réinitialisé par défaut': 'Repor predefinições',
  'Mode de rédaction': 'Modo de escrita',
  'Agent AI utilisé': 'Agente de IA utilizado',
  'Textes en brouillons': 'Rascunhos',
  'Modèle': 'Modelo',
  'Paramètres du projet': 'Definições do projeto',
  'Avancement': 'Estado',
  'Progression': 'Progresso',
  'Aucun texte disponible': 'Nenhum texto disponível',
  'Détails du projet': 'Detalhes do projeto',
  'Page {{current}} sur {{total}}': 'Página {{current}} de {{total}}',
  'Moteur LLM': 'Motor LLM',
  'Rédiger un contenu': 'Escrever conteúdo',
  'Traduire un contenu': 'Traduzir conteúdo',
  'Optimiser un contenu': 'Otimizar conteúdo',
  'Générer un contenu': 'Gerar conteúdo',

  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé':
    'Crie um texto para uma palavra-chave específica com um formulário guiado',

  'Traduire un texte spécifique avec un formulaire guidé':
    'Traduza um texto específico com um formulário guiado',

  'Générez plusieurs textes en important un fichier Excel':
    'Gere vários textos importando um ficheiro Excel',

  'Rédiger un lot de contenus': 'Escrever um lote de conteúdos',
  'Traduire un lot de contenus': 'Traduzir um lote de conteúdos',
  'Enrichir un contenu': 'Enriquecer conteúdo',

  'Optimisez un texte spécifique avec un formulaire guidé':
    'Otimize um texto específico com um formulário guiado',

  'Nombre total de textes alloués au projet':
    'Número total de textos atribuídos ao projeto',

  'Vous pourrez changer le format du contenu plus tard':
    'Poderá alterar o formato do conteúdo mais tarde',

  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)':
    'Introduza cada palavra-chave seguida da sua frequência entre parênteses e pressione Enter. Exemplo: sapatos(3)',

  'Ex: voiture(5), électrique(3), autonomie(8)':
    'Ex.: carro(5), elétrico(3), autonomia(8)',

  'URLs des pages à lier (séparées par des virgules)':
    'URLs das páginas a ligar (separados por vírgulas)',

  'Besoin d\'aide pour préparer votre fichier ?':
    'Precisa de ajuda para preparar o seu ficheiro?',

  'Télécharger le modèle (Excel)':
    'Descarregar o modelo (Excel)',

  'Déposez votre fichier ici':
    'Coloque o seu ficheiro aqui',

  'Glissez-déposez votre fichier Excel':
    'Arraste e largue o seu ficheiro Excel',

  'ou cliquez pour parcourir':
    'ou clique para procurar',

  'Formats acceptés : .xlsx, .xls (max 10 Mo)':
    'Formatos aceites: .xlsx, .xls (máx. 10 MB)',

  'Parcourir les fichiers':
    'Procurar ficheiros',

  'Ex: télépéage automatique':
    'Ex.: portagem automática',

  'Générer le contenu': 'Gerar conteúdo',
  'Lancer la génération': 'Iniciar geração',
  'Commencer la traduction': 'Iniciar tradução',
  'Lancer la traduction': 'Iniciar tradução',

  'Partager': 'Partilhar',
  'Telecharger le texte': 'Descarregar texto',
  'Modifier le projet': 'Editar projeto',
  'Modifiez les détails de votre projet ici.':
    'Edite os detalhes do seu projeto aqui.',

  'Général': 'Geral',
  'Allocation des textes': 'Atribuição de textos',
  'Sélectionner un format du contenu': 'Selecionar um formato de conteúdo',
  'Allocation aux rédacteurs': 'Atribuição aos redatores',

  '{{count}} textes disponibles':
    '{{count}} textos disponíveis',

  'Sélectionner un rédacteur': 'Selecionar um redator',
  'Nom du rédacteur': 'Nome do redator',
  'Date limite': 'Prazo',
  'texte restant': 'textos restantes',
  'textes alloués': 'textos atribuídos',

  'Article court - 300 mots': 'Artigo curto – 300 palavras',
  'Article moyen - 600 mots': 'Artigo médio – 600 palavras',
  'Article long - 1000 words': 'Artigo longo – 1000 palavras',
  'Youtube - 350 mots': 'YouTube – 350 palavras',
  'Linkedin - 200 mots': 'LinkedIn – 200 palavras',
  'X - 150 mots': 'X – 150 palavras',
  'Personnalisé': 'Personalizado',

  'Voir plus': 'Ver mais',
  ' à votre ': ' no seu ',
  '{{count}} textes à livrer':
    '{{count}} textos a entregar',

'Nous contacter': 'Contacte-nos',
'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': 'Tem uma pergunta ou um problema? Contacte-nos e responderemos o mais rápido possível.',
'Sujet': 'Assunto',
'Message': 'Mensagem',
'Soumettre ma demande': 'Enviar meu pedido',
'Veuillez sélectionner un sujet': 'Por favor, selecione um assunto',
'Décrivez votre demande en détail...': 'Descreva seu pedido em detalhes...',
'Sélectionnez un sujet': 'Selecione um assunto',
'Autre': 'Outro',
'Feedback': 'Feedback',
'Question': 'Pergunta',
'Bug': 'Erro',
'Le message doit contenir au moins 10 caractères': 'A mensagem deve conter pelo menos 10 caracteres',
'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Sua mensagem foi enviada com sucesso. Responderemos o mais rápido possível.',
'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'Seu pedido foi enviado com sucesso para nossa equipe de suporte, que responderá o mais rápido possível.',
'Envoi en cours...': 'Enviando...',
'Fermer': 'Fechar',
'Créer un nouvel agent AI': 'Criar um novo agente de IA',
'Mission de l\'agent': 'Missão do agente',
'L\'agent générera du contenu original à partir de vos consignes.': 'O agente irá gerar conteúdo original com base nas suas instruções.',
'Informations générales': 'Informações gerais',
'Informations principales': 'Informações principais',
'Ton & audience': 'Tom e público',
'Structure & rédaction': 'Estrutura e redação',
'Base de connaissances': 'Base de conhecimento',
'Construction du contenu': 'Construção de conteúdo',
'Structure attendu': 'Estrutura esperada',
'Cadre lexical': 'Quadro lexical',
'Personnalisation avancée': 'Personalização avançada',
'Base de connaissance locale en ligne': 'Base de conhecimento local online',
'Glissez-déposez votre fichier': 'Arraste e solte seu arquivo',
'Base de connaissance': 'Base de conhecimento',
'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Forneça a lista de URLs nas quais a IA pode se basear',
'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Defina o posicionamento editorial do seu agente para que ele adapte seu tom,',
'sa cible et son vocabulaire à votre activité.': 'seu público-alvo e seu vocabulário à sua atividade.',
'caractères': 'caracteres',
};
